import React, { useState, useContext } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    IconButton,
    Box,
    Container,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Menu,
    MenuItem,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import LoginIcon from "@mui/icons-material/Login";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import DownloadForOfflineOutlinedIcon from "@mui/icons-material/DownloadForOfflineOutlined";

import LoginModal from "./LoginModal";
import { AuthContext } from "../context/AuthContext";

function Navbar() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [desktopMenuAnchor, setDesktopMenuAnchor] = useState(null);
    const [openLogin, setOpenLogin] = useState(false);

    const { username, role, logout, token, authChecked } = useContext(AuthContext);
    const location = useLocation();

    const toggleDrawer = (open) => () => {
        setMobileOpen(open);
    };

    const handleDesktopMenuOpen = (event) => {
        setDesktopMenuAnchor(event.currentTarget);
    };

    const handleDesktopMenuClose = () => {
        setDesktopMenuAnchor(null);
    };

    const handleLogout = async () => {
        handleDesktopMenuClose();
        setMobileOpen(false);
        await logout();
    };

    const navItems = [
        {
            label: "Главная",
            to: "/",
            icon: <HomeOutlinedIcon fontSize="small" />,
        },
        {
            label: "Проверка ПП",
            to: "/check-pp",
            icon: <FactCheckOutlinedIcon fontSize="small" />,
        },
        {
            label: "Сверка HR",
            to: "/check-hr",
            icon: <PeopleAltOutlinedIcon fontSize="small" />,
        },
        {
            label: "Конвертор ПП",
            to: "/convert-pp",
            icon: <ReceiptLongOutlinedIcon fontSize="small" />,
        },
        {
            label: "Контакты",
            to: "/contacts",
            icon: <ContactsOutlinedIcon fontSize="small" />,
        },

        {
            label: "Загрузки",
            to: "/downloads",
            icon: <DownloadForOfflineOutlinedIcon fontSize="small" />,
        },

    ];

    const userMenuItems = [];
    if (role === "admin") {
        userMenuItems.push({
            label: "Админпанель",
            to: "/adminpanel",
            icon: <AdminPanelSettingsOutlinedIcon fontSize="small" />,
        });
    }
    if (role === "manager") {
        userMenuItems.push({
            label: "Пользователи",
            to: "/manager",
            icon: <GroupOutlinedIcon fontSize="small" />,
        });
    }
    if (role === "user") {
        userMenuItems.push({
            label: "Профиль",
            to: "/profile",
            icon: <PersonOutlineOutlinedIcon fontSize="small" />,
        });
    }

    const isActive = (path) => location.pathname === path;

    const drawerContent = (
        <Box
            sx={{
                width: 300,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                bgcolor: "#ffffff",
            }}
            role="presentation"
        >
            <Box
                sx={{
                    px: 2,
                    py: 1.6,
                    borderBottom: "1px solid rgba(148, 163, 184, 0.18)",
                    background: "linear-gradient(180deg, #eff6ff 0%, #ffffff 100%)",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1.5,
                    }}
                >
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 900,
                                color: "#0f172a",
                                letterSpacing: "-0.02em",
                                lineHeight: 1.1,
                            }}
                        >
                            Qarzhy.kz
                        </Typography>

                    </Box>

                    <IconButton
                        onClick={toggleDrawer(false)}
                        sx={{
                            width: 38,
                            height: 38,
                            border: "1px solid rgba(148, 163, 184, 0.20)",
                            bgcolor: "#ffffff",
                            color: "#334155",
                            flexShrink: 0,
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Box>

            <List sx={{ px: 1.2, py: 1.2 }}>
                {navItems.map((item) => (
                    <ListItemButton
                        key={item.label}
                        component={Link}
                        to={item.to}
                        onClick={toggleDrawer(false)}
                        sx={{
                            borderRadius: 2.5,
                            mb: 0.6,
                            py: 1.05,
                            bgcolor: isActive(item.to) ? "rgba(37, 99, 235, 0.08)" : "transparent",
                            "&:hover": {
                                bgcolor: "rgba(37, 99, 235, 0.08)",
                            },
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 36, color: "#2563eb" }}>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={item.label}
                            primaryTypographyProps={{
                                fontWeight: 700,
                                color: "#0f172a",
                                fontSize: "0.95rem",
                            }}
                        />
                    </ListItemButton>
                ))}
            </List>

            <Divider sx={{ mx: 2 }} />

            <Box sx={{ p: 2, pt: 1.4 }}>
                {!authChecked ? (
                    <Box sx={{ height: 44 }} />
                ) : token ? (
                    <>

                        {authChecked && token && (
                            <Box
                                sx={{
                                    mb: 1.4,
                                    px: 1,
                                    py: 1,
                                    borderRadius: 2.5,
                                    bgcolor: "rgba(37, 99, 235, 0.06)",
                                    border: "1px solid rgba(37, 99, 235, 0.10)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "0.75rem",
                                        fontWeight: 700,
                                        color: "#64748b",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.04em",
                                        mb: 0.3,
                                    }}
                                >
                                    Пользователь
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "0.95rem",
                                        fontWeight: 800,
                                        color: "#0f172a",
                                        wordBreak: "break-word",
                                        lineHeight: 1.4,
                                    }}
                                >
                                    {username}
                                </Typography>
                            </Box>
                        )}


                        {userMenuItems.length > 0 && (
                            <List sx={{ p: 0, mb: 1 }}>
                                {userMenuItems.map((item) => (
                                    <ListItemButton
                                        key={item.label}
                                        component={Link}
                                        to={item.to}
                                        onClick={toggleDrawer(false)}
                                        sx={{
                                            borderRadius: 2.5,
                                            mb: 0.6,
                                            py: 1.05,
                                            bgcolor: isActive(item.to) ? "rgba(37, 99, 235, 0.08)" : "transparent",
                                            "&:hover": {
                                                bgcolor: "rgba(37, 99, 235, 0.08)",
                                            },
                                        }}
                                    >
                                        <ListItemIcon sx={{ minWidth: 36, color: "#2563eb" }}>
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={item.label}
                                            primaryTypographyProps={{
                                                fontWeight: 700,
                                                color: "#0f172a",
                                                fontSize: "0.95rem",
                                            }}
                                        />
                                    </ListItemButton>
                                ))}
                            </List>
                        )}

                        <Button
                            fullWidth
                            onClick={handleLogout}
                            startIcon={<LogoutOutlinedIcon />}
                            variant="contained"
                            sx={{
                                borderRadius: 2.5,
                                textTransform: "none",
                                fontWeight: 700,
                                boxShadow: "none",
                            }}
                        >
                            Выйти
                        </Button>
                    </>
                ) : (
                    <Button
                        fullWidth
                        onClick={() => {
                            setMobileOpen(false);
                            setOpenLogin(true);
                        }}
                        startIcon={<LoginIcon />}
                        variant="contained"
                        sx={{
                            borderRadius: 2.5,
                            textTransform: "none",
                            fontWeight: 700,
                            boxShadow: "none",
                        }}
                    >
                        Войти
                    </Button>
                )}
            </Box>
        </Box>
    );

    return (
        <>
            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    bgcolor: "rgba(255, 255, 255, 0.82)",
                    backdropFilter: "blur(14px)",
                    borderBottom: "1px solid rgba(148, 163, 184, 0.18)",
                    color: "#0f172a",
                    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
                }}
            >
                <Container maxWidth="xl">
                    <Toolbar
                        disableGutters
                        sx={{
                            minHeight: { xs: 64, md: 70 },
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr auto", md: "auto 1fr auto" },
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <Box
                            component={Link}
                            to="/"
                            sx={{
                                textDecoration: "none",
                                display: "flex",
                                alignItems: "center",
                                minWidth: 0,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: { xs: "1.12rem", md: "1.2rem" },
                                    fontWeight: 900,
                                    color: "#0f172a",
                                    letterSpacing: "-0.03em",
                                    lineHeight: 1.1,
                                }}
                            >
                                Qarzhy.kz
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: { xs: "none", md: "flex" },
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 0.6,
                                minWidth: 0,
                            }}
                        >
                            {navItems.map((item) => (
                                <Button
                                    key={item.label}
                                    component={Link}
                                    to={item.to}
                                    color="inherit"
                                    sx={{
                                        px: 1.6,
                                        py: 1,
                                        borderRadius: 2.5,
                                        textTransform: "none",
                                        fontWeight: 700,
                                        fontSize: "0.95rem",
                                        color: isActive(item.to) ? "#0f172a" : "#334155",
                                        bgcolor: isActive(item.to) ? "rgba(37, 99, 235, 0.08)" : "transparent",
                                        "&:hover": {
                                            bgcolor: "rgba(37, 99, 235, 0.08)",
                                            color: "#0f172a",
                                        },
                                    }}
                                >
                                    {item.label}
                                </Button>
                            ))}
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: 1,
                                minWidth: 0,
                            }}
                        >
                            {authChecked && token && (
                                <Typography
                                    sx={{
                                        display: { xs: "none", md: "block" },
                                        maxWidth: 180,
                                        fontSize: "0.93rem",
                                        fontWeight: 700,
                                        color: "#334155",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {username}
                                </Typography>
                            )}

                            {authChecked && token ? (
                                <IconButton
                                    onClick={handleDesktopMenuOpen}
                                    sx={{
                                        display: { xs: "none", md: "inline-flex" },
                                        width: 42,
                                        height: 42,
                                        border: "1px solid rgba(148, 163, 184, 0.22)",
                                        bgcolor: "#ffffff",
                                        color: "#334155",
                                        "&:hover": {
                                            bgcolor: "rgba(37, 99, 235, 0.08)",
                                        },
                                    }}
                                >
                                    <MenuIcon />
                                </IconButton>
                            ) : null}

                            <IconButton
                                onClick={toggleDrawer(true)}
                                sx={{
                                    display: { xs: "inline-flex", md: "none" },
                                    width: 42,
                                    height: 42,
                                    border: "1px solid rgba(148, 163, 184, 0.22)",
                                    bgcolor: "#ffffff",
                                    color: "#334155",
                                    "&:hover": {
                                        bgcolor: "rgba(37, 99, 235, 0.08)",
                                    },
                                }}
                            >
                                <MenuIcon />
                            </IconButton>

                            {!token && authChecked && (
                                <Button
                                    onClick={() => setOpenLogin(true)}
                                    variant="contained"
                                    sx={{
                                        display: { xs: "none", md: "inline-flex" },
                                        borderRadius: 2.5,
                                        textTransform: "none",
                                        fontWeight: 700,
                                        px: 2.2,
                                        py: 1,
                                        boxShadow: "none",
                                    }}
                                >
                                    Войти
                                </Button>
                            )}
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>

            <Menu
                anchorEl={desktopMenuAnchor}
                open={Boolean(desktopMenuAnchor)}
                onClose={handleDesktopMenuClose}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                PaperProps={{
                    sx: {
                        mt: 1,
                        minWidth: 220,
                        borderRadius: 3,
                        border: "1px solid rgba(148, 163, 184, 0.18)",
                        boxShadow: "0 18px 40px rgba(15, 23, 42, 0.10)",
                        overflow: "hidden",
                    },
                }}
            >
                {userMenuItems.map((item) => (
                    <MenuItem
                        key={item.label}
                        component={Link}
                        to={item.to}
                        onClick={handleDesktopMenuClose}
                        sx={{
                            gap: 1.2,
                            py: 1.2,
                            fontWeight: 600,
                            fontSize: "0.95rem",
                        }}
                    >
                        {item.icon}
                        {item.label}
                    </MenuItem>
                ))}

                <Divider />

                <MenuItem
                    onClick={handleLogout}
                    sx={{
                        gap: 1.2,
                        py: 1.2,
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        color: "#b91c1c",
                    }}
                >
                    <LogoutOutlinedIcon fontSize="small" />
                    Выйти
                </MenuItem>
            </Menu>

            <Drawer
                anchor="right"
                open={mobileOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        boxShadow: "0 20px 50px rgba(15, 23, 42, 0.16)",
                    },
                }}
            >
                {drawerContent}
            </Drawer>

            <LoginModal
                open={openLogin}
                onClose={() => setOpenLogin(false)}
            />
        </>
    );
}

export default Navbar;